import { render, staticRenderFns } from "./api-image.vue?vue&type=template&id=660a4d74&scoped=true&"
import script from "./api-image.vue?vue&type=script&lang=js&"
export * from "./api-image.vue?vue&type=script&lang=js&"
import style0 from "./api-image.vue?vue&type=style&index=0&id=660a4d74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660a4d74",
  null
  
)

export default component.exports